module.exports = __webpack_public_path__ + "static/media/shirt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/default/shirt.svg
// module id = 54
// module chunks = 0